import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

const ZONE = {
  'Nord-Ovest': ['Piemonte', "Valle d'Aosta", 'Lombardia', 'Liguria'],
  'Nord-Est':   ['Trentino-Alto Adige', 'Veneto', 'Friuli-Venezia Giulia', 'Emilia-Romagna'],
  'Centro':     ['Toscana', 'Umbria', 'Marche', 'Lazio'],
  'Sud':        ['Abruzzo', 'Molise', 'Campania', 'Puglia', 'Basilicata', 'Calabria'],
  'Isole':      ['Sicilia', 'Sardegna'],
};

function Contatti({ destinatariId = 31, onSelectionChange }) {
  const [contatti, setContatti] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterTipoEnte, setFilterTipoEnte] = useState('');
  const [filterZona, setFilterZona] = useState('');
  const [filterRegione, setFilterRegione] = useState('');
  const [filterProvincia, setFilterProvincia] = useState('');
  const [filterSocio, setFilterSocio] = useState('');
  
  // FILTRO INTERVALLO RIGHE
  const [filterRigaDa, setFilterRigaDa] = useState('');
  const [filterRigaA, setFilterRigaA] = useState('');
  
  // STANDARDIZZAZIONE ORDINAMENTO - COME ALTRI COMPONENTI
  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  
  const [selected, setSelected] = useState({});
  const [processingSelection, setProcessingSelection] = useState(false);

  // 🔧 NUOVO: SISTEMA TOGGLE COLONNE
  const [hiddenColumns, setHiddenColumns] = useState({
    indice: false,
    ragioneSociale: false,
    tipoEnte: false,
    comune: false,
    siglaProv: false,
    regione: false,
    socio: false,
    emailOrd: false,
    emailPec: false
  });

  // 🔧 CARICA CONFIGURAZIONE COLONNE DA LOCALSTORAGE
  useEffect(() => {
    try {
      const savedConfig = localStorage.getItem('contatti_hidden_columns');
      if (savedConfig) {
        const parsedConfig = JSON.parse(savedConfig);
        setHiddenColumns(prevConfig => ({
          ...prevConfig,
          ...parsedConfig
        }));
        console.log('✅ Configurazione colonne caricata:', parsedConfig);
      }
    } catch (error) {
      console.error('❌ Errore caricamento configurazione colonne:', error);
    }
  }, []);

  // 🔧 SALVA CONFIGURAZIONE COLONNE IN LOCALSTORAGE
  useEffect(() => {
    try {
      localStorage.setItem('contatti_hidden_columns', JSON.stringify(hiddenColumns));
      console.log('💾 Configurazione colonne salvata:', hiddenColumns);
    } catch (error) {
      console.error('❌ Errore salvataggio configurazione colonne:', error);
    }
  }, [hiddenColumns]);

  // 🔧 FUNZIONE TOGGLE SINGOLA COLONNA
  const toggleColumn = (columnKey) => {
    setHiddenColumns(prev => ({
      ...prev,
      [columnKey]: !prev[columnKey]
    }));
  };

  // 🔧 FUNZIONE RIPRISTINA TUTTE LE COLONNE
  const resetColumns = () => {
    setHiddenColumns({
      indice: false,
      ragioneSociale: false,
      tipoEnte: false,
      comune: false,
      siglaProv: false,
      regione: false,
      socio: false,
      emailOrd: false,
      emailPec: false
    });
  };

  // 🔧 CONTA COLONNE NASCOSTE
  const hiddenCount = Object.values(hiddenColumns).filter(Boolean).length;

  useEffect(() => {
    async function fetchContatti() {
      setLoading(true);
      try {
        const response = await apiFetch(`/api/Contact/destinatari/${destinatariId}`);
        if (response.ok) {
          const data = await response.json();
          const raw = Array.isArray(data.destinatari) ? data.destinatari : [];
          const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
          const mapped = raw.map((d, idx) => ({
            // AGGIUNTO INDICE PROGRESSIVO
            indice: idx + 1, // Indice partendo da 1
            ragioneSociale: d.ragione_sociale || '',
            tipoEnte: d.tipo_ente || '',
            comune: d.comune || '',
            siglaProv: d.siglaprov || '',
            regione: d.regione || '',
            socio: d.socio || '',
            emailOrd: d.email ? d.email.split(';').map(e => e.trim()).filter(isValidEmail) : [],
            emailPec: d.pec ? d.pec.split(';').map(e => e.trim()).filter(isValidEmail) : [],
            id: d.id,
            key: `${d.ragione_sociale || ''}_${d.siglaprov || ''}_${d.comune || ''}_${idx}`
          }));
          console.log('Contatti mappati:', mapped);
          setContatti(mapped);
          setFiltered(mapped);
        } else {
          setContatti([]);
          setFiltered([]);
        }
      } catch {
        setContatti([]);
        setFiltered([]);
      }
      setLoading(false);
    }
    fetchContatti();
  }, [destinatariId]);

  // FILTRI OTTIMIZZATI - CON FILTRO INTERVALLO RIGHE
  useEffect(() => {
    setProcessingSelection(true);
    
    setTimeout(() => {
      let f = Array.isArray(contatti) ? contatti : [];
      
      // FILTRO RICERCA TESTUALE
      if (searchTerm && searchTerm.trim().length >= 3) {
        const term = searchTerm.trim().toLowerCase();
        f = f.filter(d =>
          (d.ragioneSociale || '').toLowerCase().includes(term) ||
          (d.comune || '').toLowerCase().includes(term)
        );
      }
      
      // FILTRO TIPO ENTE
      if (filterTipoEnte) {
        const tipo = filterTipoEnte.toLowerCase();
        f = f.filter(d => (d.tipoEnte || '').toLowerCase().includes(tipo));
      }
      
      // FILTRO ZONA
      if (filterZona && ZONE[filterZona]) {
        const regioni = ZONE[filterZona].map(r => r.toLowerCase());
        f = f.filter(d => regioni.includes((d.regione || '').toLowerCase()));
      }

      // FILTRO REGIONE
      if (filterRegione) {
        const reg = filterRegione.toLowerCase();
        f = f.filter(d => (d.regione || '').toLowerCase().includes(reg));
      }
      
      // FILTRO PROVINCIA
      if (filterProvincia) {
        const prov = filterProvincia.toLowerCase();
        f = f.filter(d => (d.siglaProv || '').toLowerCase().includes(prov));
      }
      
      // FILTRO SOCIO
      if (filterSocio) {
        f = f.filter(d => d.socio === filterSocio);
      }
      
      // ORDINAMENTO PRIMA DEL FILTRO INTERVALLO
      if (sortField) {
        f = [...f].sort((a, b) => {
          let valueA = a[sortField];
          let valueB = b[sortField];
          
          if (valueA == null) valueA = '';
          if (valueB == null) valueB = '';
          
          valueA = String(valueA).toLowerCase();
          valueB = String(valueB).toLowerCase();
          
          if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
          if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
          return 0;
        });
      }
      
      // NUOVO FILTRO INTERVALLO RIGHE (APPLICATO DOPO ORDINAMENTO)
      if (filterRigaDa.trim() || filterRigaA.trim()) {
        const rigaDa = filterRigaDa.trim() ? parseInt(filterRigaDa.trim()) : 1;
        const rigaA = filterRigaA.trim() ? parseInt(filterRigaA.trim()) : f.length;
        
        // Validazione intervallo
        if (!isNaN(rigaDa) && !isNaN(rigaA) && rigaDa > 0 && rigaDa <= rigaA) {
          // Filtra per intervallo (indici array partono da 0, ma mostriamo da 1)
          f = f.slice(rigaDa - 1, rigaA);
          console.log(`🔢 Filtro intervallo: righe ${rigaDa}-${rigaA} (${f.length} elementi)`);
        }
      }
      
      setFiltered(f);
      setProcessingSelection(false);
    }, 0);
  }, [searchTerm, filterTipoEnte, filterZona, filterRegione, filterProvincia, filterSocio, filterRigaDa, filterRigaA, contatti, sortField, sortDirection]);

  // SELEZIONE OTTIMIZZATA
  const handleSelect = (key, checked) => {
    setSelected(prev => {
      const updated = { ...prev, [key]: checked };
      if (onSelectionChange) {
        const selRows = filtered.filter(d => updated[getKey(d)]);
        const sample = selRows[0] || filtered[0] || {};
        const fieldPlaceholders = Object.keys(sample)
          .filter(k => !['emailOrd', 'emailPec', 'key', 'indice'].includes(k)) // ESCLUSO indice dai placeholder
          .map(k => `{${k.toUpperCase()}}`);
        const genericPlaceholders = ['{DATA_ODIERNA}', '{IMMAGINE_INTESTAZIONE}', '{IMMAGINE_FONDO}', '{FIRMA_ANUTEL}'];
        const placeholders = Array.from(new Set([...fieldPlaceholders, ...genericPlaceholders]));
        
        onSelectionChange({
          selectedRows: selRows,
          destinatariCount: selRows.length,
          emailCount: selRows.reduce((sum, d) => sum + (d.emailOrd?.length || 0) + (d.emailPec?.length || 0), 0),
          placeholders: placeholders
        });
      }
      return updated;
    });
  };
  
  const handleSelectAll = (checked) => {
    setProcessingSelection(true);
    setTimeout(() => {
      if (checked) {
        const newSel = {};
        for (let i = 0; i < filtered.length; i++) {
          newSel[getKey(filtered[i])] = true;
        }
        setSelected(newSel);
        if (onSelectionChange) {
          const sample = filtered[0] || {};
          const fieldPlaceholders = Object.keys(sample)
            .filter(k => !['emailOrd', 'emailPec', 'key', 'indice'].includes(k)) // ESCLUSO indice
            .map(k => `{${k.toUpperCase()}}`);
          const genericPlaceholders = ['{DATA_ODIERNA}', '{IMMAGINE_INTESTAZIONE}', '{IMMAGINE_FONDO}', '{FIRMA_ANUTEL}'];
          const placeholders = Array.from(new Set([...fieldPlaceholders, ...genericPlaceholders]));
          
          onSelectionChange({
            selectedRows: filtered,
            destinatariCount: filtered.length,
            emailCount: filtered.reduce((sum, d) => sum + (d.emailOrd?.length || 0) + (d.emailPec?.length || 0), 0),
            placeholders: placeholders
          });
        }
      } else {
        setSelected({});
        if (onSelectionChange) onSelectionChange({
          selectedRows: [],
          destinatariCount: 0,
          emailCount: 0,
          placeholders: []
        });
      }
      setProcessingSelection(false);
    }, 0);
  };
  
  const getKey = d => d.key;

  const handleSort = (field) => {
    setProcessingSelection(true);
    
    setSortField(prevField => {
      setSortDirection(prevDirection => {
        if (prevField === field) {
          return prevDirection === 'asc' ? 'desc' : 'asc';
        } else {
          return 'asc';
        }
      });
      return field;
    });
  };

  const getSortIcon = (field) => {
    if (sortField !== field) {
      // 🔧 PROVA DIVERSE VERSIONI DELL'ICONA DOPPIA FRECCIA
      return (
        <span style={{cursor: 'pointer'}} title="Clicca per ordinare">
          {/* Opzione 1: Icona Font Awesome standard */}
          <i className="fas fa-sort text-muted" style={{fontSize: '12px'}}></i>
          
          {/* 🔧 FALLBACK: Se l'icona non si vede, usa simbolo Unicode */}
          <span className="text-muted" style={{fontSize: '12px', fontWeight: 'bold', display: 'none'}} id="fallback-sort">
            ⇅
          </span>
          
          {/* 🔧 FALLBACK 2: Due frecce separate */}
          <span className="text-muted" style={{fontSize: '10px', display: 'none'}} id="fallback-arrows">
            <i className="fas fa-caret-up"></i>
            <i className="fas fa-caret-down"></i>
          </span>
        </span>
      );
    }
    // Mostra direzione attuale quando è il campo ordinato
    return sortDirection === 'asc' ? 
      <i className="fas fa-sort-up text-info" style={{fontSize: '12px', cursor: 'pointer'}} title="Ordinamento crescente - Clicca per decrescente"></i> : 
      <i className="fas fa-sort-down text-info" style={{fontSize: '12px', cursor: 'pointer'}} title="Ordinamento decrescente - Clicca per crescente"></i>;
  };

  const getSortIconAlternative = (field) => {
    if (sortField !== field) {
      // 🔧 SEMPRE VISIBILE: Due frecce separate
      return (
        <span style={{cursor: 'pointer'}} title="Clicca per ordinare">
          <span className="d-flex flex-column align-items-center" style={{lineHeight: '0.6'}}>
            <i className="fas fa-caret-up text-muted" style={{fontSize: '8px', marginBottom: '1px'}}></i>
            <i className="fas fa-caret-down text-muted" style={{fontSize: '8px'}}></i>
          </span>
        </span>
      );
    }
    // Mostra direzione attuale
    return sortDirection === 'asc' ? 
      <i className="fas fa-caret-up text-info" style={{fontSize: '12px', cursor: 'pointer'}} title="Ordinamento crescente - Clicca per decrescente"></i> : 
      <i className="fas fa-caret-down text-info" style={{fontSize: '12px', cursor: 'pointer'}} title="Ordinamento decrescente - Clicca per crescente"></i>;
  }; 

  const getSortIconFixed = (field) => {
    if (sortField !== field) {
      // 🔧 SIMBOLO UNICODE SEMPRE VISIBILE
      return (
        <span 
          style={{
            cursor: 'pointer', 
            fontSize: '12px', 
            color: '#6c757d',
            fontWeight: 'bold',
            userSelect: 'none'
          }} 
          title="Clicca per ordinare"
        >
          ⇵
        </span>
      );
    }
    // Mostra direzione attuale con icone Font Awesome
    return sortDirection === 'asc' ? 
      <span 
        style={{cursor: 'pointer', fontSize: '12px', color: '#0dcaf0'}} 
        title="Ordinamento crescente - Clicca per decrescente"
      >
        ▲
      </span> : 
      <span 
        style={{cursor: 'pointer', fontSize: '12px', color: '#0dcaf0'}} 
        title="Ordinamento decrescente - Clicca per crescente"
      >
        ▼
      </span>;
  };

  // FUNZIONE PER CALCOLARE INDICE VISUALIZZATO NELLA TABELLA
  const getDisplayIndex = (itemIndice, currentIndex) => {
    // Se c'è un filtro intervallo attivo, mostra l'indice relativo all'intervallo
    if (filterRigaDa.trim()) {
      const rigaDa = parseInt(filterRigaDa.trim()) || 1;
      return rigaDa + currentIndex;
    }
    // Altrimenti mostra l'indice originale del dataset completo
    return itemIndice;
  };

  // 🔧 HELPER PER ICONA TOGGLE COLONNA
  const getColumnToggleIcon = (columnKey) => {
    return hiddenColumns[columnKey] ? 
      <i 
        className="fas fa-eye-slash text-danger" 
        style={{fontSize: '13px'}}
        title="Colonna nascosta - Clicca per mostrare"
      ></i> : 
      <i 
        className="fas fa-eye text-success" 
        style={{fontSize: '13px'}}
        title="Colonna visibile - Clicca per nascondere"
      ></i>;
  };

  // 🔧 HELPER PER STILE COLONNA
  const getColumnStyle = (columnKey) => {
    return {
      display: hiddenColumns[columnKey] ? 'none' : 'table-cell',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    };
  };

  // Contatori
  const safeFiltered = Array.isArray(filtered) ? filtered : [];
  const totalItems = safeFiltered.length;
  const totalEmails = safeFiltered.reduce((sum, d) => sum + (d.emailOrd?.length || 0) + (d.emailPec?.length || 0), 0);
  const selectedCount = Object.values(selected).filter(Boolean).length;
  const selectedEmails = safeFiltered.filter(d => selected[getKey(d)]).reduce((sum, d) => sum + (d.emailOrd?.length || 0) + (d.emailPec?.length || 0), 0);

  const sample = safeFiltered.find(d => selected[getKey(d)]) || safeFiltered[0] || {};
  const fieldPlaceholders = Object.keys(sample)
    .filter(k => !['emailOrd', 'emailPec', 'key', 'indice'].includes(k))
    .map(k => `{${k.toUpperCase()}}`);
  const genericPlaceholders = ['{DATA_ODIERNA}', '{IMMAGINE_INTESTAZIONE}', '{IMMAGINE_FONDO}', '{FIRMA_ANUTEL}'];
  const placeholders = Array.from(new Set([...fieldPlaceholders, ...genericPlaceholders]));
  const selectedRows = safeFiltered.filter(d => selected[getKey(d)]);

  return (
    <>
      <div className="card mb-4">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0"><i className="fas fa-users"></i> 1. Seleziona Destinatari</h5>
            <div className="d-flex align-items-center">
              <span className="badge bg-success me-2">
                <i className="fas fa-check-circle me-1"></i> Elementi Selezionati: {selectedCount}
              </span>
              <span className="badge bg-info">
                <i className="fas fa-envelope me-1"></i> Email Selezionate: {selectedEmails}
              </span>
            </div>
          </div>
        </div>
        <div className="card-body">
          {/* FILTRI AGGIORNATI CON INTERVALLO RIGHE */}
          <div className="row mb-2">
            {/* PRIMA RIGA - Filtri principali */}
            <div className="col-md-4">
              <label className="form-label fw-bold text-start w-100"><i className="fas fa-search me-1 text-muted"></i> Ricerca:</label>
              <input type="text" className="form-control" placeholder="Ragione sociale o comune..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold text-start w-100"><i className="fas fa-building me-1 text-muted"></i> Tipo Ente:</label>
              <select className="form-select" value={filterTipoEnte} onChange={e => setFilterTipoEnte(e.target.value)}>
                <option value="">Tutti</option>
                <option value="COMUNE">COMUNE</option>
                <option value="PROVINCIA">PROVINCIA</option>
                <option value="REGIONE">REGIONE</option>
                <option value="UNIONE">UNIONE</option>
                <option value="ASSOCIAZIONE">ASSOCIAZIONE</option>
                <option value="SOCIETA'">SOCIETA'</option>
                <option value="PERSONA">PERSONA</option>
                <option value="ALTRO">ALTRO</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold text-start w-100"><i className="fas fa-map-marked-alt me-1 text-muted"></i> Zona:</label>
              <select className="form-select" value={filterZona} onChange={e => { setFilterZona(e.target.value); setFilterRegione(''); }}>
                <option value="">Tutte le zone</option>
                {Object.keys(ZONE).map(z => <option key={z} value={z}>{z}</option>)}
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold text-start w-100"><i className="fas fa-map me-1 text-muted"></i> Regione:</label>
              <input type="text" className="form-control" placeholder="Nome regione..." value={filterRegione} onChange={e => { setFilterRegione(e.target.value); setFilterZona(''); }} />
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold text-start w-100"><i className="fas fa-map-marker-alt me-1 text-muted"></i> Provincia:</label>
              <input type="text" className="form-control" placeholder="Sigla..." value={filterProvincia} onChange={e => setFilterProvincia(e.target.value)} />
            </div>
          </div>

          <div className="row mb-3">
            {/* SECONDA RIGA - Filtri avanzati e contatori */}
            <div className="col-md-2">
              <label className="form-label fw-bold text-start w-100"><i className="fas fa-user-check me-1 text-muted"></i> Socio:</label>
              <select className="form-select" value={filterSocio} onChange={e => setFilterSocio(e.target.value)}>
                <option value="">Tutti</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </select>
            </div>
            {/* FILTRO INTERVALLO RIGHE - PIÙ LARGO */}
            <div className="col-md-4">
              <label className="form-label fw-bold text-start w-100"><i className="fas fa-list-ol me-1 text-muted"></i> Intervallo Righe:
                <span className="text-primary" style={{fontSize: '80%', marginLeft: '10px'}}>
                  {filterRigaDa.trim() || filterRigaA.trim() ? 
                    `Righe ${filterRigaDa || '1'}-${filterRigaA || contatti.length}` : 
                    'Tutte le righe'
                  }
                </span>
              </label>
              <div className="d-flex">
                <input 
                  type="number" 
                  className="form-control me-1" 
                  placeholder="Da riga..." 
                  min="1"
                  value={filterRigaDa} 
                  onChange={e => setFilterRigaDa(e.target.value)}
                />
                <input 
                  type="number" 
                  className="form-control" 
                  placeholder="A riga..." 
                  min="1"
                  value={filterRigaA} 
                  onChange={e => setFilterRigaA(e.target.value)}
                />
              </div>
            </div>
            
            {/* 🔧 NUOVO: PULSANTE RIPRISTINA COLONNE */}
            <div className="col-md-3 d-flex align-items-end">
              <div className="w-100">
                <button 
                  className={`btn btn-outline-secondary btn-sm w-100 ${hiddenCount > 0 ? 'btn-outline-warning' : ''}`}
                  onClick={resetColumns}
                  title="Ripristina tutte le colonne nascoste"
                >
                  <i className="fas fa-columns me-1"></i> 
                  Ripristina Colonne
                  {hiddenCount > 0 && (
                    <span className="badge bg-warning text-dark ms-2">{hiddenCount}</span>
                  )}
                </button>
                <small className="text-muted d-block mt-1 text-center">
                  {hiddenCount === 0 ? 
                    'Tutte le colonne visibili' : 
                    `${hiddenCount} colonna${hiddenCount > 1 ? 'e' : ''} nascosta${hiddenCount > 1 ? 'e' : ''}`
                  }
                </small>
              </div>
            </div>
            
            {/* CONTATORI - PIÙ GRANDI */}
            <div className="col-md-3 d-flex align-items-end">
              <div className="w-100">
                <div className="row text-center">
                  <div className="col-6">
                    <small className="text-muted"><i className="fas fa-list-ol"></i> Elementi</small>
                    <div className="h5 text-primary mb-0">{totalItems}</div>
                  </div>
                  <div className="col-6">
                    <small className="text-muted"><i className="fas fa-at"></i> Email totali</small>
                    <div className="h5 text-info mb-0">{totalEmails}</div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          
          {/* 🔧 TABELLA CON TOGGLE COLONNE */}
          <div className="table-responsive position-relative" style={{ maxHeight: 400, overflowY: 'auto' }}>
            {(loading || processingSelection) && (
              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-white bg-opacity-75" style={{zIndex:10}}>
                <i className="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
                <div className="fw-bold fs-5">
                  {loading ? 'Caricamento in corso...' : 'Aggiornamento selezione...'}
                </div>
              </div>
            )}
            <table className="table table-striped table-hover mb-0">
              <thead className="table-dark sticky-top">
                <tr>
                  {/* CHECKBOX SELEZIONE - SEMPRE VISIBILE */}
                  <th style={{minWidth: '50px', verticalAlign: 'middle'}}>
                    <input 
                      type="checkbox" 
                      checked={selectedCount === filtered.length && filtered.length > 0} 
                      ref={el => { if (el) el.indeterminate = selectedCount > 0 && selectedCount < filtered.length; }} 
                      onChange={e => handleSelectAll(e.target.checked)} 
                    />
                  </th>
                  
                  {/* 🔧 COLONNA INDICE CON EVENTI SEPARATI */}
                  <th 
                    style={{...getColumnStyle('indice'), minWidth: '80px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('indice')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-hashtag text-muted me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('indice'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('indice')}
                        </span>
                        <span 
                          onClick={(e) => { e.stopPropagation(); handleSort('indice'); }}
                          className="ms-1"
                        >
                          {getSortIconFixed('indice')}
                        </span>
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA - NON PIÙ CLICCABILE PER ORDINAMENTO */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Indice
                      </div>
                    </div>
                  </th>
                  
                  {/* 🔧 RAGIONE SOCIALE CON EVENTI SEPARATI */}
                  <th 
                    style={{...getColumnStyle('ragioneSociale'), minWidth: '200px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('ragioneSociale')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-building text-primary me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('ragioneSociale'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('ragioneSociale')}
                        </span>
                        <span 
                          onClick={(e) => { e.stopPropagation(); handleSort('ragioneSociale'); }}
                          className="ms-1"
                        >
                          {getSortIconFixed('ragioneSociale')}
                        </span>
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Ragione Sociale
                      </div>
                    </div>
                  </th>
                  
                  {/* 🔧 TIPO ENTE CON EVENTI SEPARATI */}
                  <th 
                    style={{...getColumnStyle('tipoEnte'), minWidth: '120px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('tipoEnte')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-tag text-info me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('tipoEnte'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('tipoEnte')}
                        </span>
                        <span 
                          onClick={(e) => { e.stopPropagation(); handleSort('tipoEnte'); }}
                          className="ms-1"
                        >
                          {getSortIconFixed('tipoEnte')}
                        </span>
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Tipo Ente
                      </div>
                    </div>
                  </th>
                  
                  {/* 🔧 COMUNE CON EVENTI SEPARATI */}
                  <th 
                    style={{...getColumnStyle('comune'), minWidth: '150px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('comune')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-city text-success me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('comune'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('comune')}
                        </span>
                        <span 
                          onClick={(e) => { e.stopPropagation(); handleSort('comune'); }}
                          className="ms-1"
                        >
                          {getSortIconFixed('comune')}
                        </span>
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Comune
                      </div>
                    </div>
                  </th>
                  
                  {/* 🔧 PROVINCIA CON EVENTI SEPARATI */}
                  <th 
                    style={{...getColumnStyle('siglaProv'), minWidth: '100px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('siglaProv')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-map-marker-alt text-warning me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('siglaProv'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('siglaProv')}
                        </span>
                        <span 
                          onClick={(e) => { e.stopPropagation(); handleSort('siglaProv'); }}
                          className="ms-1"
                        >
                          {getSortIconFixed('siglaProv')}
                        </span>
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Provincia
                      </div>
                    </div>
                  </th>
                  
                  {/* 🔧 REGIONE CON EVENTI SEPARATI */}
                  <th 
                    style={{...getColumnStyle('regione'), minWidth: '130px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('regione')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-map text-secondary me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('regione'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('regione')}
                        </span>
                        <span 
                          onClick={(e) => { e.stopPropagation(); handleSort('regione'); }}
                          className="ms-1"
                        >
                          {getSortIconFixed('regione')}
                        </span>
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Regione
                      </div>
                    </div>
                  </th>
                  
                  {/* 🔧 SOCIO CON EVENTI SEPARATI */}
                  <th 
                    style={{...getColumnStyle('socio'), minWidth: '100px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('socio')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-user-check text-success me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('socio'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('socio')}
                        </span>
                        <span 
                          onClick={(e) => { e.stopPropagation(); handleSort('socio'); }}
                          className="ms-1"
                        >
                          {getSortIconFixed('socio')}
                        </span>
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Socio
                      </div>
                    </div>
                  </th>
                  
                  {/* 🔧 EMAIL ORD - SENZA ORDINAMENTO, SOLO TOGGLE */}
                  <th 
                    style={{...getColumnStyle('emailOrd'), minWidth: '130px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('emailOrd')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-envelope text-primary me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('emailOrd'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('emailOrd')}
                        </span>
                        {/* NESSUNA ICONA ORDINAMENTO PER LE EMAIL */}
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Email ORD
                      </div>
                    </div>
                  </th>
                  
                  {/* 🔧 EMAIL PEC - SENZA ORDINAMENTO, SOLO TOGGLE */}
                  <th 
                    style={{...getColumnStyle('emailPec'), minWidth: '130px', padding: '8px'}}
                    onDoubleClick={() => toggleColumn('emailPec')}
                  >
                    <div className="text-center">
                      {/* PRIMA RIGA: ICONE */}
                      <div className="d-flex justify-content-center align-items-center mb-1" style={{height: '20px'}}>
                        <i className="fas fa-certificate text-warning me-2" style={{fontSize: '14px'}}></i>
                        <span 
                          onClick={(e) => { e.stopPropagation(); toggleColumn('emailPec'); }}
                          style={{cursor: 'pointer'}}
                        >
                          {getColumnToggleIcon('emailPec')}
                        </span>
                        {/* NESSUNA ICONA ORDINAMENTO PER LE EMAIL */}
                      </div>
                      {/* SECONDA RIGA: NOME COLONNA */}
                      <div className="fw-bold" style={{fontSize: '12px', lineHeight: '1.2'}}>
                        Email PEC
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filtered.length > 0 ? filtered.map((d, currentIndex) => (
                  <tr key={getKey(d)}>
                    {/* CHECKBOX SELEZIONE - SEMPRE VISIBILE */}
                    <td>
                      <input 
                        type="checkbox" 
                        checked={!!selected[getKey(d)]} 
                        onChange={e => handleSelect(getKey(d), e.target.checked)} 
                      />
                    </td>
                    
                    {/* 🔧 CELLE CON STILE DINAMICO */}
                    <td style={getColumnStyle('indice')}>
                      <span className="badge bg-secondary">
                        {getDisplayIndex(d.indice, currentIndex)}
                      </span>
                    </td>
                    
                    <td style={getColumnStyle('ragioneSociale')}>
                      {d.ragioneSociale && d.ragioneSociale.trim() ? d.ragioneSociale : '-'}
                    </td>
                    
                    <td style={getColumnStyle('tipoEnte')}>
                      <span className="badge bg-info">
                        {d.tipoEnte && d.tipoEnte.trim() ? d.tipoEnte : '-'}
                      </span>
                    </td>
                    
                    <td style={getColumnStyle('comune')}>
                      {d.comune}
                    </td>
                    
                    <td style={getColumnStyle('siglaProv')}>
                      {d.siglaProv}
                    </td>
                    
                    <td style={getColumnStyle('regione')}>
                      {d.regione}
                    </td>
                    
                    <td style={getColumnStyle('socio')}>
                      <span className={`badge ${d.socio === 'SI' ? 'bg-success' : 'bg-secondary'}`}>
                        {d.socio === 'SI' ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>} {d.socio}
                      </span>
                    </td>
                    
                    <td style={getColumnStyle('emailOrd')}>
                      <span className="badge bg-primary">{d.emailOrd?.length || 0}</span>
                      {d.emailOrd?.length > 0 && (
                        <small className="text-muted d-block">
                          {d.emailOrd.slice(0,2).join(', ')}
                        </small>
                      )}
                    </td>
                    
                    <td style={getColumnStyle('emailPec')}>
                      <span className="badge bg-warning">{d.emailPec?.length || 0}</span>
                      {d.emailPec?.length > 0 && (
                        <small className="text-muted d-block">
                          {d.emailPec.slice(0,2).join(', ')}
                        </small>
                      )}
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={10} className="text-center text-muted py-4">
                      <i className="fas fa-address-book fa-2x mb-2"></i><br />
                      Nessun contatto trovato
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contatti;